app.controller("SudoGradesExportListController", [
    "$scope", "StaticData", "SysParam", "$stateParams", "$state", "SudoUtilsService", "$uibModal", "usSpinnerService", "ConfirmModal", "toastr",
    function ($scope, StaticData, SysParam, $stateParams, $state, SudoUtilsService, $uibModal, usSpinnerService, ConfirmModal, toastr) {
        $scope.query = $stateParams.query;
        $scope.itemsPerPage = 25;
        $scope.totalItems = 0;

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.reload = function(){
            loadPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            SudoUtilsService.getGradesExportList({
                season: $stateParams.season || $scope.filterSeason,
                page: page,
                query: $stateParams.query,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                $scope.files = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.submitQuery = function () {
            $state.go(".", {query: $scope.query, season: $scope.filterSeason});
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "SudoAddGradesExportController",
                templateUrl: _pb + 'sudo/utils/add-grades-export.html',
                size: "md"
            }).result
                .then(function (result) {
                    $state.go(".");
                }, function () {
                });
        };

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

    }
]);